<template>
  <div class='ClientCheckout'>
    <checkout-item
    v-for="(i, key) in CheckoutItens01"
    :key="key"
    :data="i"
    />
    <div class="value">
      <div style="text-align: left">SubTotal</div>
      <div style="text-align: right">{{ CheckoutTotal01.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
    </div>
    <div class="value">
      <div v-if="CheckoutTotal01 <= freteValorMin" style="width: 100%;color: red;line-height: 22px;">
        Entrega a domicílio apenas para compras acima de {{ Frete.valormin }}
      </div>
      <!-- <div v-if="CheckoutTotal01 >= freteValorMin" style="text-align: left">Frete ({{ Frete.tipo }})</div> -->
      <div v-if="CheckoutTotal01 >= freteValorMin" style="text-align: left">Deslocamento</div>
      <div v-if="CheckoutTotal01 >= freteValorMin" style="text-align: right">{{ ValorFrete.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
    </div>
    <div class="value">
      <div style="text-align: left">Desconto</div>
      <div style="text-align: right">{{ cupom.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
    </div>
    <div class="value total">
      <div style="text-align: left">Total</div>
      <div style="text-align: right">
        {{
          freteValorMin > CheckoutTotal01
          ?
          (CheckoutTotal01 - cupom.valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
          :
          ((CheckoutTotal01 + ValorFrete) - cupom.valor).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})
        }}
      </div>
    </div>
    <input-gift/>
    <div class="ajust-layout"></div>
    <div v-if="PaymentBrick && Empresa.mp && !PixApproved" id="paymentBrick_container"></div>
    <div class="cont-button" v-if="PaymentBrick && Empresa.mp">
      <div class="ajust-layout"></div>
      <button v-if="!LoadPay" @click="payment">Pagar</button>
      <component
      :is="Prefes.spinner.tipo"
      :color="Prefes.spinner.cor"
      :size="Prefes.spinner.tipo === 'EnbSyncLoader' ? '12px' : '40px'"
      style="z-index: 999"
      v-if="LoadPay"
      />
    </div>
    <div class="pixapproved" v-if="PixApproved">Pagamento aprovado</div>
    <div class="statusBrick" v-if="PaymentStatus && Empresa.mp && !PixApproved" id="statusScreenBrick_container"></div>
    <div class="cont-button" v-if="TryAgainPay">
      <button @click="push" v-if="TryAgainPay">Tentar novamente</button>
    </div>
    <button @click="$router.push('/pedidos')" class="status-pedido" v-if="PedidoAtual.length > 0 && PedidoAtual[0].status === 'Recebido' && Empresa.mp && !TryAgainPay">Situação do pedido</button>
    <enb-whatsapp :validate="v$" v-if="Empresa.wa"/>
    <div v-if="v$.$error && !Object.keys(Profile).length" class="error-form">
      Preencha todos os campos obrigatórios em vermelho e tente novamente!
    </div>
  </div>
</template>

<script>
import { loadMercadoPago } from '@mercadopago/sdk-js'
import { renderPaymentBrick } from './renderPaymentBrick'
import { mapGetters, mapActions } from 'vuex'
import CheckoutItem from './CheckoutItem'
import EnbWhatsapp from './EnbWhatsapp'
import InputGift from './InputGift'
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength, helpers } from '@vuelidate/validators'
import createPayment from './createPayment'
import { loaders } from '@/components/Spinner'
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  name: 'ClientCheckout',
  components: { CheckoutItem, EnbWhatsapp, InputGift, ...loaders },
  data () {
    return {
      createPayment: null
    }
  },
  computed: {
    ...mapGetters(['ClientValidate', 'ValorFrete', 'LoadPay', 'cupom', 'CheckoutItens01', 'SelectedClientEdit', 'CheckoutTotal01', 'Prefes', 'PaymentBrick', 'PaymentStatus', 'Profile', 'PedidoAtual', 'TryAgainPay', 'Empresa', 'Frete', 'PixApproved']),
    usuario () {
      return this.SelectedClientEdit.usuario.usuario
    },
    email () {
      return this.SelectedClientEdit.usuario.email
    },
    nome () {
      return this.SelectedClientEdit.usuario.nome
    },
    sobrenome () {
      return this.SelectedClientEdit.usuario.sobrenome
    },
    cpf () {
      return this.SelectedClientEdit.endereco.cpf
    },
    celular () {
      return this.SelectedClientEdit.endereco.celular
    },
    cep () {
      return this.SelectedClientEdit.endereco.cep
    },
    bairro () {
      return this.SelectedClientEdit.endereco.bairro
    },
    endereco () {
      return this.SelectedClientEdit.endereco.endereco
    },
    numero () {
      return this.SelectedClientEdit.endereco.numero
    },
    cidade () {
      return this.SelectedClientEdit.endereco.cidade
    },
    uf () {
      return this.SelectedClientEdit.endereco.uf
    },
    senha () {
      return this.SelectedClientEdit.usuario.senha
    },
    csenha () {
      return this.SelectedClientEdit.usuario.csenha
    },
    freteValorMin () {
      return parseFloat(this.Frete.valormin.replace('R$',  '').replace(',', '.'))
    }
  },
  methods: {
    ...mapActions([
      'VerifyUserEmailHas',
      'PushClient',
      'PushPedido',
      'PushMsg',
      'ClearCheckout01',
      'GetLogin',
      'ViewPaymentMp',
      'SetTryAgainPay',
      'GetFrete',
      'GetFreteBairro',
      'LoadingPay',
      'setValorFrete',
      'setPixPaymentStatus'
    ]),
    async push () {
      this.SetTryAgainPay(false)
      await loadMercadoPago()
      const mp = new window.MercadoPago(this.Empresa.publickey)
      this.ViewPaymentMp({ comp: 'PaymentStatus', status: false })
        .then(() => this.ViewPaymentMp({ comp: 'PaymentBrick', status: true }))
        .then(() => renderPaymentBrick(mp.bricks(), this.$store))
    },
    async userHas (str) { return await this.VerifyUserEmailHas({ user: str, email: str }).then(res => res.user) },
    async emailHas (str) { return await this.VerifyUserEmailHas({ user: str, email: str }).then(res => res.email) },
    payment () {
      this.LoadingPay(true)
      this.createPayment()
    }
  },
  async created () {
    this.GetFrete()
      .then(() => this.GetFreteBairro())
      .then(() => {
        if(this.Frete.tipo === 'Taxa fixa') {
          let gratisapartir = parseFloat(this.Frete.gratisapartir.replace('R$', '').replace(',', '.'))
          let valor = parseFloat(this.Frete.valor.replace('R$', '').replace(',', '.'))
          if(this.CheckoutTotal01 < gratisapartir || gratisapartir <= 0) {
            this.setValorFrete(valor)
          }
        }
      })
    await loadMercadoPago()
    const mp = new window.MercadoPago(this.Empresa.publickey)
    renderPaymentBrick(mp.bricks(), this.$store)
    this.createPayment = createPayment(mp.bricks(), this.$store, this.v$)
  },
  validations () {
    return {
      usuario: {
        required,
        minLength: minLength(4),
        has: helpers.withMessage('Nome de usuário não disponível', helpers.withAsync(this.userHas))
      },
      email: {
        required,
        email,
        has: helpers.withMessage('Email não disponível', helpers.withAsync(this.emailHas))
      },
      nome: {
        required
      },
      sobrenome: {
        required
      },
      cpf: {
        required,
        minLength: minLength(14)
      },
      celular: {
        required,
        minLength: minLength(15)
      },
      cep: {
        required,
        minLength: minLength(9)
      },
      bairro: {
        required
      },
      endereco: {
        required
      },
      numero: {
        required
      },
      cidade: {
        required
      },
      uf: {
        required,
        minLength: minLength(2)
      },
      senha: {
        required,
        minLength: minLength(6)
      },
      csenha: {
        required,
        minLength: minLength(6),
        sameAs: (s) => s === this.senha
      }
    }
  },
  beforeUnmount () {
    this.setPixPaymentStatus(false)
  }
}
</script>

<style scoped>
.ClientCheckout {
  width: 96%;
  height: 92%;
  padding: 2%;
  padding-top: 4%;
}

.value {
  display: flex;
  padding: 4%;
  border-top: thin solid #CCCCCC;
  font-size: 18px;
}

.value div {
  width: 50%;
}

.total {
  font-size: 22px;
}

.cont-button {
  padding-bottom: 4%;
}

button {
  border: 0;
  width: 50%;
  height: 45px;
  font-size: 16px;
  border-radius: 8px;
  color: #FFFFFF;
  cursor: pointer;
  background-color: #056ac8;
  font-weight: bold;
}

.status-pedido {
  margin-top: 2%;
  background-color: #056ac8;
}

.statusBrick {
  margin-top: 5%;
}

.error-form {
  color: red;
  font-size: 18px;
  padding: 5%;
  line-height: 22px;
}

.ajust-layout {
  width: 100%;
  height: 20px;
}

.pixapproved {
  width: 70%;
  background-color: #FFFFFF;
  border: thin solid #056ac8;
  border-radius: 5px;
  color: #056ac8;
  padding: 2%;
  font-weight: bold;
  margin: auto;
}
</style>
